import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import {
  Observable, catchError, map, of, take,
} from 'rxjs';

import { UserRole } from '../models/user.model';

import { AuthService } from './auth.service';

export const adminGuard: CanActivateFn = (): Observable<boolean> | boolean => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.user$.pipe(
    take(1),
    map(user => {
      if (user?.userRole === UserRole.Admin) {
        return true;
      } else {
        router.navigate([ '/' ]);

        return false;
      }
    }),
    catchError(() => {
      router.navigate([ '/' ]);

      return of(false);
    })
  );
};
